import Repository from "./repository"

const resource = 'integration'

export default {
    async GetSurvey({ surveyId }) {
        let endpoint = `${resource}/surveys/${surveyId}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async existSurvey({ surveyId }) {
        let endpoint = `${resource}/surveys/${surveyId}/exists`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getBio({ id }) {
        let endpoint = `${resource}/bio/${id}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getBioByRoom({ id }) {
        let endpoint = `${resource}/bio/room/${id}`;
        let response = await Repository.get(endpoint);
        return response;
    }
}